import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Field, Segment, TextArea } from "../components/ui";
import AppHeader from "../components/AppHeader";

export default function CustomerNew() {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [form, setForm] = useState({
    company_name: "", brand_name: "", contact_person: "",
    phone: "", whatsapp: "", same_as_phone: false, email: "",
    gst_status: "registered", gst_number: "",
    billing_address: "", shipping_address: "", same_as_billing: false,
  });
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async () => {
    setError("");
    if (!form.company_name || !form.brand_name || !form.contact_person || !form.phone || !form.email) {
      setError("Company, brand, contact, phone & email are required.");
      return;
    }
    if (form.gst_status === "registered" && !form.gst_number.trim()) {
      setError("GST number is required for registered companies.");
      return;
    }
    try {
      setBusy(true);
      await api.post("/customers", {
        ...form,
        gst_number: form.gst_status === "registered" ? form.gst_number.trim().toUpperCase() : null,
        whatsapp: form.same_as_phone ? form.phone : (form.whatsapp || form.phone),
      });
      navigate("/customers");
    } catch (e) {
      setError(e?.message || "Could not save customer");
    } finally { setBusy(false); }
  };

  return (
    <>
      <AppHeader title="New Customer" back />
      <div className="sg-main sg-fade-in">
        <Field label="Company name" value={form.company_name} onChange={(e) => set("company_name", e.target.value)} placeholder="Acme Apparels Pvt Ltd" data-testid="customer-company" />
        <Field label="Brand name" value={form.brand_name} onChange={(e) => set("brand_name", e.target.value)} placeholder="Acme" data-testid="customer-brand" />
        <Field label="Contact person" value={form.contact_person} onChange={(e) => set("contact_person", e.target.value)} placeholder="Riya Sharma" data-testid="customer-person" />
        <Field label="Phone number" value={form.phone} onChange={(e) => set("phone", e.target.value)} placeholder="+91 98xxx xxxxx" type="tel" data-testid="customer-phone" />
        <Field label="Whatsapp" value={form.same_as_phone ? form.phone : form.whatsapp} onChange={(e) => set("whatsapp", e.target.value)} disabled={form.same_as_phone} placeholder="+91 98xxx xxxxx" type="tel" data-testid="customer-whatsapp" />
        <label style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12, cursor: "pointer" }}>
          <input type="checkbox" checked={form.same_as_phone} onChange={(e) => set("same_as_phone", e.target.checked)} data-testid="customer-same-toggle" />
          <span style={{ fontSize: 13 }}>Same as Contact Number</span>
        </label>
        <Field label="Email" type="email" value={form.email} onChange={(e) => set("email", e.target.value)} placeholder="hello@brand.com" data-testid="customer-email" />

        <label className="sg-label">GST Status</label>
        <Segment
          options={[
            { key: "registered", label: "Registered" },
            { key: "applied", label: "Applied" },
            { key: "unregistered", label: "Unregistered" },
          ]}
          value={form.gst_status}
          onChange={(v) => set("gst_status", v)}
          testIdPrefix="customer-gst"
        />
        {form.gst_status === "registered" && (
          <Field label="GST number (required)" value={form.gst_number} onChange={(e) => set("gst_number", e.target.value.toUpperCase())} placeholder="29ABCDE1234F1Z5" data-testid="customer-gst-number" />
        )}

        <TextArea label="Billing address" value={form.billing_address} onChange={(e) => set("billing_address", e.target.value)} />
        <label style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12, cursor: "pointer" }}>
          <input type="checkbox" checked={form.same_as_billing} onChange={(e) => set("same_as_billing", e.target.checked)} />
          <span style={{ fontSize: 13 }}>Shipping same as billing</span>
        </label>
        {!form.same_as_billing && <TextArea label="Shipping address" value={form.shipping_address} onChange={(e) => set("shipping_address", e.target.value)} />}

        {error && <div style={{ color: "var(--danger)", fontSize: 13, marginBottom: 12 }}>{error}</div>}

        <button className="sg-btn sg-btn-primary" onClick={submit} disabled={busy} data-testid="customer-save" style={{ width: "100%", marginTop: 12 }}>
          {busy ? "Saving..." : "Save Customer"}
        </button>
      </div>
    </>
  );
}
